try{self['workbox:sw:7.0.0']&&_()}catch(e){}// eslint-disable-line